import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const CtaBanner = () => (
  <section
    data-testid="cta-banner"
    className="relative overflow-hidden border-t border-[#27272A] py-28 sm:py-36"
  >
    <div
      className="pointer-events-none absolute left-1/2 top-1/2 h-[460px] w-[860px] -translate-x-1/2 -translate-y-1/2 blur-[150px]"
      style={{ background: "radial-gradient(ellipse, rgba(204,10,20,0.22), transparent 65%)" }}
    />
    <div className="relative mx-auto max-w-4xl px-5 text-center sm:px-8">
      <Reveal>
        <p className="font-jb text-xs uppercase tracking-[0.3em] text-[#CC0A14]">
          The door is open
        </p>
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="mt-6 font-syne text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl">
          STOP LIVING SOFT.
          <br />
          <span className="text-[#CC0A14]">START THE FIRST CYCLE TODAY.</span>
        </h2>
      </Reveal>
      <Reveal delay={0.2}>
        <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-zinc-400">
          The full method is published. The only thing between you and a sharper
          face is twelve weeks of doing the boring things daily.
        </p>
      </Reveal>
      <Reveal delay={0.3}>
        <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
          <Link
            data-testid="cta-method-button"
            to="/method"
            className="group flex items-center gap-3 border border-[#CC0A14] bg-[#CC0A14] px-8 py-4 font-jb text-xs font-semibold uppercase tracking-[0.22em] text-white transition-colors duration-300 hover:bg-transparent hover:text-[#CC0A14]"
          >
            Enter the Method
            <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
          <Link
            data-testid="cta-journal-button"
            to="/journal"
            className="border border-[#27272A] px-8 py-4 font-jb text-xs font-semibold uppercase tracking-[0.22em] text-zinc-300 transition-colors duration-300 hover:border-[#CC0A14] hover:text-white"
          >
            Read the Journal
          </Link>
        </div>
      </Reveal>
    </div>
  </section>
);

export default CtaBanner;
